export default __webpack_public_path__ + "static/media/face-6.08ea3e59.svg";